import { ConstantsService } from './constants.service';
import { Http, ResponseContentType, RequestOptions } from '@angular/http';
import { Injectable,  } from '@angular/core';



@Injectable()
export class ReporteGeneralService {
  private service_url: string;
  private api_url: string;
  private modulo_url: string;
  constructor(private http: Http, private constantsService: ConstantsService) {
    this.api_url = this.constantsService.apiURL;
    this.modulo_url = '/general/liquidacion';
    this.service_url = this.api_url + this.modulo_url;
  }

  public getDefaultScheduleInversionistas() {
    return {
      "obras": {},
      "liquidacion": {},
      "resultados": {},
      "generacion": "",
      "notasAdministracion": "null",
      "retornosHistoricos": [],
      "cobranza": "",
      "variacion": "",
      "fondoAhorro": {},
      "ingresos": [],
      "egresos":[],
      "imagenes":[],
      "reporteRentabilidad": {
        "tabla": [],
        "total":""
      },
      "puntoEquilibrio": "",
      "comentariosFinales": ""
    };
  }

  getReporteInversionista(token) {
    return this.http.get(this.service_url + '/inversionistas?token=' + token);
  }

  getReporteImagenComprobante(hash) {
    const requestOptions = new RequestOptions({
      'responseType': ResponseContentType.Blob
    });
    return this.http.get(this.service_url + '/comprobantes?hash=' + hash,requestOptions);
  }

  getReporteImagenComprobanteAsURL(hash) {
    return this.service_url + '/comprobantes?hash=' + hash;
  }

  public getLiquidacionByID(idLiquidacion) {
    return this.http.get(this.service_url + '/informacion?idLiquidacion=' + idLiquidacion);
  }

  public getImageUrl(id) {
    const requestOptions = new RequestOptions({
      'responseType': ResponseContentType.Blob
    });
    return this.http.get(this.service_url + '/imagen/obra?id=' + id,requestOptions);
  }

  getReporteImagen(idImagen) {
    const requestOptions = new RequestOptions({
      'responseType': ResponseContentType.Blob
    });

    return this.http.get(this.service_url + '/imagen?id=' + idImagen,requestOptions);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/reporte-general.service.ts